var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAioaIconType10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1094 -430)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1094 430)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 66,
    r: 66,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 66,
    r: 61,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1118 453.998)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.238,12.222A41.73,41.73,0,1,0,12.223,71.237,41.73,41.73,0,1,0,71.238,12.222ZM9.655,58.423a36.106,36.106,0,0,1,0-33.387l13.272,6.636a21.294,21.294,0,0,0,0,20.115ZM41.731,5.564A35.943,35.943,0,0,1,58.424,9.655L51.788,22.926a21.294,21.294,0,0,0-20.115,0L25.037,9.655A35.943,35.943,0,0,1,41.731,5.564ZM57.5,41.73A15.765,15.765,0,1,1,41.731,25.965,15.783,15.783,0,0,1,57.5,41.73ZM41.731,77.9a35.943,35.943,0,0,1-16.694-4.091l6.636-13.271a21.294,21.294,0,0,0,20.115,0l6.636,13.271A35.943,35.943,0,0,1,41.731,77.9Zm18.8-26.108a21.294,21.294,0,0,0,0-20.115l13.272-6.636a36.106,36.106,0,0,1,0,33.387Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAioaIconType10);
export default __webpack_public_path__ + "static/media/aioa-icon-type-10.9bdb38a0cbdfaa45bacb8a8fa91e36fa.svg";
export { ForwardRef as ReactComponent };